module.exports = __webpack_public_path__ + "img/3fc69e2.svg";